import { Component, OnDestroy, OnInit } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { LoadingService } from './service/loading.service';
import { AuthService } from './service/auth.service';
import { Workplace } from './model/iworkplace';
import { NavigationEnd, Router } from '@angular/router';
import { WorkplaceService } from './service/workplace.service';
import { filter, switchMap } from 'rxjs/operators';
import { of, Subscription } from 'rxjs';
import { addIcons } from 'ionicons';
import {logOut, addOutline, mail, businessOutline, caretForwardCircleOutline, clipboardOutline, peopleOutline, fileTrayStackedOutline, downloadOutline, save, calendarOutline, personCircleOutline, cardOutline, idCardOutline, pencilSharp, newspaperOutline, createOutline, documentTextSharp, trashOutline, pencilOutline, documentText, documentTextOutline, closeCircleOutline, checkmarkCircleOutline} from 'ionicons/icons'

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  imports: [IonApp, IonRouterOutlet],
})
export class AppComponent implements OnInit, OnDestroy{
  
  private readonly LAST_URL_KEY = 'lastUrl';
  private subscriptions = new Subscription();

  constructor(
    private authService: AuthService,
    private router: Router,
    public loadingService: LoadingService, 
    public workplaceService: WorkplaceService
  ) {
    addIcons({logOut, addOutline, mail, businessOutline, caretForwardCircleOutline, clipboardOutline, peopleOutline, fileTrayStackedOutline, downloadOutline, save, calendarOutline, personCircleOutline, cardOutline, idCardOutline, pencilSharp, newspaperOutline, createOutline, documentTextSharp, trashOutline, pencilOutline, documentText, documentTextOutline, closeCircleOutline, checkmarkCircleOutline});
  }
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  initializeApp() {
    const statePage = localStorage.getItem('awaitRedirect');
    if(statePage==="true"){
      this.loadingService.loadingRedirect();
    }

    if(!this.workplaceService.currentWorkplace){
      const workplaceData = localStorage.getItem('workplace');
      const myWorkplace: Workplace = workplaceData ? JSON.parse(workplaceData) : null;
      this.workplaceService.setCurrentWorkplace(myWorkplace)
    }
  }

  ngOnInit() {
    this.initializeApp();
    const authSub = this.authService.authState$.pipe(
    switchMap(user => {
      localStorage.setItem('awaitRedirect', 'false');
      if (this.loadingService.isLoading) {
        this.loadingService.dismiss();
      }
      if(!user){
        this.router.navigate(['/']);
        return of(null);
      }

      this.authService.userProfile = user;
      localStorage.setItem('uid', user.uid);

      return this.authService.getUserProfile(user.uid);

    })
    ).subscribe(profile => {
      if (this.authService.userProfile?.uid) {
        const routerSub = this.router.events
          .pipe(filter(event => event instanceof NavigationEnd))
          .subscribe((event: NavigationEnd) => {
            sessionStorage.setItem(this.LAST_URL_KEY, event.urlAfterRedirects);
          });

        this.subscriptions.add(routerSub);

        if (!profile) {
          this.authService.createAccount(this.authService.userProfile);
        }

        this.handlePostLoginNavigation();
      }
    });
    this.subscriptions.add(authSub);
  }

  private handlePostLoginNavigation(){
    const lastUrl = sessionStorage.getItem(this.LAST_URL_KEY);
    if (lastUrl && lastUrl !== "/" && lastUrl !== '/login') {
      this.router.navigateByUrl(lastUrl);
    } else {
      this.router.navigate(['workplace']);
    }
  }
}
